import type {ComponentWithAs} from '@chakra-ui/system';
import type {LabelProps} from 'recharts';

type Props = LabelProps & {fill?: string};
// This is your custom label component
const BarLabel: ComponentWithAs<'text', Props> = ({x, y, width, value, fill}) => {
  return (
    <text x={Number(x) - Number(width)} y={Number(y) + 10} fill={fill} textAnchor={`end`}>
      {value}
    </text>
  );
};

export default BarLabel;
